import React from 'react'
import { Grid, Icon, Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import styles from 'components/Breadcrumbs/breadcrumbs.module.scss'
import clsx from 'clsx'
import { Link } from 'react-router-dom'

const Breadcrumbs = ({ className, links = [] }) => {
  return (
    <Grid
      className={clsx(styles['breadcrumbs'], className)}
      gap={8}
      direction={'row'}
      alignContent={'center'}
      alignItems={'center'}
    >
      {links.map((link, index) => (
        <Grid
          gap={8}
          alignItems={'center'}
          fluid={false}
          className={clsx(styles['breadcrumbs__link'], {
            [styles['breadcrumbs__link_small']]: links.length === 1,
          })}
          key={'breadcrumb-segment-' + index}
          component={Link}
          {...(link.to ? { to: link.to } : { onClick: link.onClick })}
        >
          {links.length === 1 && (
            <Icon
              color={'inherit'}
              className={styles['breadcrumbs__arrow']}
              name={'arrow-left'}
              size={'sm'}
            />
          )}

          <Typography
            to={link.to}
            variant={'Body-15'}
          >
            {link.title}
          </Typography>
          {links.length > 1 && (
            <Icon
              color={'inherit'}
              className={styles['breadcrumbs__arrow']}
              name={'arrow-right'}
              size={'sm'}
            />
          )}
        </Grid>
      ))}
    </Grid>
  )
}

Breadcrumbs.propTypes = {
  className: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      to: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null]), PropTypes.func]),
    }),
  ),
}

export default Breadcrumbs
